import styles from './CameraController.module.scss';
import classes from 'classnames';

interface CameraControllerProps {
  off?: boolean;
  onClick?: () => void;
  layout?: '' | 'camera';
}

const CameraController = ({ off = false, onClick, layout = '' }: CameraControllerProps) => {
  return (
    <button
      onClick={onClick}
      className={classes(styles.btn, {
        [styles[`btn-${layout}`]]: !!layout,
      })}
    >
      <svg
        viewBox='0 0 512 512'
        className={classes({
          [styles.off]: off,
        })}
      >
        <path className={styles.line} />
        <path className={classes(styles.camera, styles.cameraPart1)} />
        <path className={classes(styles.camera, styles.cameraPart2)} />
      </svg>
    </button>
  );
};

export default CameraController;
